import React from 'react';
import Lightbox from 'react-images';

export class ImageGrid extends React.Component {
	constructor () {
		super();

		this.state = {
			lightboxIsOpen: false,
			currentImage: 0,
		};

		this.closeLightbox = this.closeLightbox.bind(this);
		this.gotoNext = this.gotoNext.bind(this);
		this.gotoPrevious = this.gotoPrevious.bind(this);
		this.gotoImage = this.gotoImage.bind(this);
		this.handleClickImage = this.handleClickImage.bind(this);
		this.openLightbox = this.openLightbox.bind(this);
	}
	openLightbox (index, event) {
		event.preventDefault();
		this.setState({
			currentImage: index,
			lightboxIsOpen: true,
		});
	}
	closeLightbox () {
		this.setState({
			currentImage: 0,
			lightboxIsOpen: false,
		});
	}
	gotoPrevious () {
		this.setState({
			currentImage: this.state.currentImage - 1,
		});
	}
	gotoNext () {
		this.setState({
			currentImage: this.state.currentImage + 1,
		});
	}
	gotoImage (index) {
		this.setState({
			currentImage: index,
		});
	}
	handleClickImage () {
		if (this.state.currentImage === this.props.items.length - 1) return;

		this.gotoNext();
	}
	renderImageGrid () {

		const { items } = this.props;
    const { itemsTotal } = this.props;

		if (!items) return;

		const imagegrid = items.map((item, i) => {
			console.log(item)
      let itemStyle = {
        backgroundImage: `url(${item.thumbnail})`,
        backgroundPosition: item.position.x + '% ' + item.position.y + '%'
      };

      let caption = null;
      if(item.img.caption && itemsTotal < 3) {
        caption = <div className="caption text-imagegrid-caption">{item.img.caption}</div>
	  }
	  
	  let copyrightTextColor = null;
	  if(item.copyright) {
		  copyrightTextColor = item.copyright.color
	  }

			return (
        <div key={i} className={"flex-item flex-item-" + item.index}>
          <div className="image-wrapper">
				<a
					href={item.thumbnail}
					className="image"
					style={itemStyle}
					onClick={(e) => this.openLightbox(i, e)}
				>
				</a>
				<span className={"copyright desktop text-copyright-" + copyrightTextColor}>{item.copyright && item.copyright.text}</span>
			</div>
          {caption}
        </div>
			);
		});

		return (
      <div className="flex-container">
			   {imagegrid}
      </div>
		);
	}
	render () {
    const images = [];
    this.props.items.map((item, i) => {
      images[i] = item.img;
    });


    return (
      <div className="test">
        {this.renderImageGrid()}
        <Lightbox
          currentImage={this.state.currentImage}
          images={images}
          isOpen={this.state.lightboxIsOpen}
          onClickImage={this.handleClickImage}
          onClickNext={this.gotoNext}
          onClickPrev={this.gotoPrevious}
          onClickThumbnail={this.gotoImage}
          onClose={this.closeLightbox}
        />
      </div>
    );
	}
}